import { ServiceSessionUserEvent } from '@modules/ServiceModule/workspace/types/ServiceEvents';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { TaskState } from '@modules/TasksModule/types';
import { setExternalCallToWrapup } from '../callHandlers/externalCalls';

function handleSessionHangup(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  const task = TasksModule.getTask(event.sessionSid);
  if (task?.state === TaskState.Accepted) {
    setExternalCallToWrapup(context, event.sessionSid, event.userId);
  }
}

export default handleSessionHangup;
